<template>
  <div class="groupChat">
    <el-dialog title="聊天记录" :visible.sync="dialogTableVisible">
      <commonTable
        :key="currentId"
        ref="commonTable"
        url="/admin/work_weixin/chatDetail"
        reqMethod="GET"
        :column="chatColumn"
        :extraParams="{
          id: currentId
        }"
        limitKey="per_page"
      >
        <el-table-column label="聊天内容">
          <template slot-scope="scope">
            <audio
              v-if="scope.row.content_type === 'voice'"
              style="width: 180px;"
              :src="scope.row.content"
              controls>
            </audio>
            <video
              v-else-if="scope.row.content_type === 'video'"
              :src="scope.row.content"
              width="200" height="100"
              controls></video>
            <el-image
              v-else-if="['image', 'emotion'].includes(scope.row.content_type)"
              style="width: 100px; height: 100px"
              :src="scope.row.content" 
              :preview-src-list="[scope.row.content]">
            </el-image>
            <span v-else>{{scope.row.content}}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间">
          <template slot-scope="scope">
            <span>{{scope.row.chat_at}}</span>
          </template>
        </el-table-column>
      </commonTable>
    </el-dialog>
    <commonTable
      ref="commonTable"
      url="/admin/work_weixin/groupChatIndex"
      reqMethod="GET"
      :column="column"
      :searchColumn="searchColumn"
      limitKey="per_page"
    >
      <el-table-column label="操作" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="small"
            plain
            v-if="hasPermission('聊天详细列表')"
            @click="() => {
              currentId = scope.row.id
              dialogTableVisible = true
            }"
            >详情</el-button>
        </template>
      </el-table-column>
    </commonTable>
  </div>
</template>

<script>
import commonTable from '@/component/commonTable.vue'

export default {
  name: 'groupChat',
  data () {
    return {
      dialogTableVisible: false,
      currentId: null,
    }
  },
  computed: {
    chatColumn () {
      return [
        {
          label: "发送方",
          prop: "send_name"
        },
      ]
    },
    column () {
      return [
        {
          label: "群名",
          prop: "room_name"
        },
        {
          label: "最近聊天时间",
          prop: "chat_at"
        },
      ]
    },
    searchColumn () {
      return [
        {
          label: "群名",
          prop: "room_name",
          type: "input",
        },
      ]
    }
  },
  components: {
    commonTable
  }
}
</script>

<style lang="less">
.groupChat .el-image-viewer__close {
  top: 100px;
  color: red;
}
</style>
